export let routine =`
<div>
<p class="ql-align-center" style="text-align: center !important;"><em>RESTRICTED</em></p>

<div class="ql-align-center">
<h3><p>HQ 91 Mech Bde</p>
<p>Katsina Road</p>
<p>PMB 3993</p> <p>Kaduna</p>
</h3>
</div>
91 BDE/11/G7							

<div class="ql-align-center">
<h3><p>062-4413674 Ext 15</p>
</h3>
</div> <br> 							





<div class="ql-align-center">
<h3><p style='color:red'>April 2013</p>
</h3>
</div>


<div>

See Distribution,

<p><u><strong>HQ 9 MECH DIV THIRD QUARTER OFFICERS’ TRAINING  </u></strong></p><br>
<p>Reference:</p><br>
<p>A.	9 DIV/317/G7 dated 11 Apr 13.</p><br>
<p>1. In Reference A, HQ 9 Mech Div Officers’ Training Day for Third          Quarter 2013 scheduled to come up on 15 Jul 13.  The aim of the training day is to expand officers’ knowledge of Peace Support Operations, especially as 2 units of the Division will soon be deployed to Darfur.</p>
<br>
<p>2. Four lectures are to be delivered during the training day. The high-point of the exercise would be a lecture on ‘Challenges of Contemporary African Conflicts: Darfur Crisis in Perspective’ to be delivered by the GOC 9 Mech Div, Maj Gen AS Agha-Okoro.  The programme for the training period is at Annex A. </p><br>
<p>3. Units under command are to nominate 5 officers each to attend the training day.  Your nominations are to reach this HQ NLT 30 Jun 13 </p>
</div><br>

<div class="ql-align-center">


<h3>



<br>
<p style="color:red"><strong>OJ OCHIGBO</strong></p>
<p>Lt Col</p>
<p>for Comd</p>
</h3>


</div>
</p>






<p class="ql-align-justify" style="text-align: center;"><em style='color: rgb(0, 0, 0); font-family: "Times New Roman"; font-size: medium; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: left; text-indent: 0px; text-transform: none; white-space: normal; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;'>RESTRICTED</em>&nbsp;</p>

</div>

`